import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useGetCompaniesQuery } from '../services/api';

const useCompanyOptions = () => {
    const { role, assignedCompanies } = useSelector((state) => state.global);

    // Only fetch companies if the user is a Super Admin or Power Admin
    const { data: companyData, refetch } = useGetCompaniesQuery(undefined, {
        skip: role !== 'Super Admin' && role !== 'Power Admin',
    });

    const companyOptions = useMemo(() => {
        if (!companyData) return [];

        let options = companyData.map((company) => ({
            id: company._id,
            name: company.name,
            alternativeName: company.alternativeName || 'N/A',
            address: (company.address?.addressLines || []).join(', '),
            city: company.address?.city || 'N/A',
            country: company.address?.country || 'N/A',
            industry: company.industry || 'N/A',
            contactEmail: company.contact?.email || 'N/A',
            contactPhone: company.contact?.phone || 'N/A',
            website: company.website || 'N/A',
            userLimit: company.userLimit || 'N/A',
            devicesConnected: company.devicesConnected.length,
            sitesConnected: company.sitesConnected.length,
            logicsConnected: company.logicsConnected.length,
            usersConnected: company.usersConnected.length,
        }));

        // Filter assigned companies for Power Admin
        if (role === 'Power Admin') {
            options = options.filter((company) => assignedCompanies.includes(company.name));
        }

        return options;
    }, [companyData, role, assignedCompanies]);

    return { companyOptions, refetchCompanyOptions: refetch };
};

export default useCompanyOptions;
